import React from 'react';

import Loading from '@justgiving/loading';

import { OwnerType } from '../../../types/__generated__';
import PAGE_TYPES from '../../constants/pageTypes';
import { useBasePageQuery, usePageMeta } from '../../hooks';
import { useProduct } from '../../hooks/page/product/useProduct';
import QRImg from './QRImg';

import styles from './QRWrapper.scss';

interface Props {
  url: string;
  label?: string | null;
}

const QRWrapper: React.FunctionComponent<Props> = ({ url, label }) => {
  return (
    <div
      className={`jg-bd jg-bd--solid jg-bd--very-light-grey jg-text--center ${styles['jg-qrwrapper--ticket']}`}
    >
      <div
        className={`jg-space-phml jg-position-relative ${styles['qr-header']}`}
      >
        <div className="jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-pvmd">
          <span className={styles['divider--left']} />
          <span className={styles['divider--right']} />
          <div className="jg-display-flex jg-flex-aic">
            <Label label={label} />
          </div>
        </div>
      </div>
      <QRImg url={url} />
    </div>
  );
};

const Label: React.FunctionComponent<Pick<Props, 'label'>> = ({ label }) => {
  const { loading } = useProduct();
  const productLabel = useProductOwner();

  if (label) {
    return <Heading label={label} />;
  }

  if (loading) {
    return <Loading size="medium" />;
  }

  return <Heading label={productLabel} />;
};

const Heading: React.FunctionComponent<Pick<Props, 'label'>> = ({ label }) => {
  return (
    <h2 className="jg-space-mn jg-h4">
      {label ? `${label}'s JustGiving Page` : `JustGiving Page`}
    </h2>
  );
};

function useProductOwner() {
  const { pageType } = usePageMeta();
  const {
    data: { ownerType },
  } = useProduct();
  const { data } = useBasePageQuery();

  switch (true) {
    case pageType === PAGE_TYPES.CAMPAIGN ||
      ownerType === OwnerType.Organisation:
      return data?.page?.title;
    case pageType === PAGE_TYPES.FUNDRAISING ||
      ownerType === OwnerType.Individual:
    default:
      return data?.page?.owner?.name;
  }
}

export default QRWrapper;
